<gd-dialog-container (close)="cancel()" [class]="size">
  <div class="header" data-lokalise data-key="txt_product_template_variant_selection_modal_title"></div>

  <div class="content">
    <p data-lokalise data-key="txt_product_template_variant_selection_modal_description"></p>

    <gd-store-products-list-item
      [item]="productsTreeItem$ | async"
      [storeType]="storeType"
      [multipleSelectionEnabled]="false"
      [isSelectVariants]="true"
      [showExpandVariantsButton]="false"
      [checkedProductVariantIds]="checkedProductVariantIds$ | async"
      (checkedProductVariantIdsChange)="onCheckedProductVariantIdsChange($event)"
    >
    </gd-store-products-list-item>
  </div>

  <div class="actions">
    <button class="ui secondary button" (click)="cancel()" data-lokalise data-key="txt_cancel"></button>

    <button
      class="ui primary button disabled"
      [class.disabled]="!(selectedProductVariant$ | async)"
      (click)="continue()"
      data-lokalise
      data-key="txt_continue"
    ></button>
  </div>
</gd-dialog-container>
